import { useQueryClient } from "react-query";
import { useParams } from "react-router-dom";
import API from "../../../services/API";
import { useContext } from "react";
import ToastContext from "../../../services/Context/ToastContext"
import { txt } from "../../../services/translation";

export default function useCreateAuditQuestion(){

    const {id} = useParams()

    const {setToast} = useContext(ToastContext)

    const queryClient = useQueryClient()

    const queryKey = ['design', id, 'audit'];

    return async () => {

        const oldQuestions = [...queryClient.getQueryData(queryKey)];

        let newQuestion = {
            title: '',
            rank: oldQuestions.length + 1,
            recommendation: ''
        }

        const response = await API.post(`/courses/${id}/audit/questions`, newQuestion);

        console.log(response.data)

        if(response.status === 201){

            newQuestion = {...response.data, edit: true};

            let newQuestions = [...queryClient.getQueryData(queryKey)];

            newQuestions.push(newQuestion);

            queryClient.setQueryData(queryKey, newQuestions);

        }else{

            queryClient.setQueryData(queryKey, oldQuestions)

            setToast({
                severity: 'error',
                message: txt('errorOccurred')
            })
        }

        return response;
    }
}